/**
 * @description 인증 관련 쿼리 키 모음
 * currentUser: 현재 로그인한 사용자 정보 조회 키
 */

export const authKeys = {
  all: ['auth'] as const,

  currentUserPrefix: () => [...authKeys.all, 'currentUser'] as const,
  currentUser: () => [...authKeys.currentUserPrefix()] as const,
} as const;
